import React from 'react'

const Hero = () => {
  return (
    <section id="hero" className="hero">
      <div className="container">
        <div className="hero-content">
          <h1>You dream it, we build it.</h1>
          <p>
            Delivering robust web, Salesforce, cloud, and AI solutions to
            elevate your business.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Hero